<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>手数料情報</mat-card-title>
    </mat-card-header>
    <div formGroupName="reginf">
        <mat-card-content>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field [appearance]="getAppearance('companycode')"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>会社</mat-label>
                    <mat-select formControlName="companycode" class="disabled-select-color">
                        <mat-option *ngFor="let type of companyList" [value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field [appearance]="getAppearance('rcvmnyAreacode')"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>入金地区</mat-label>
                    <mat-select formControlName="rcvmnyAreacode" class="disabled-select-color">
                        <mat-option *ngFor="let type of rcvmnyAreaList" [value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field [appearance]="getAppearance('kouzaRcvmnyDate')"
                    class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label class="mat-label-important">口座入金年月日</mat-label>
                    <input matInput [matDatepicker]="kouzaRcvmnyDate" autocomplete="off" class="font-color-display-only"
                        formControlName="kouzaRcvmnyDate" maxlength="10">
                    <mat-datepicker-toggle matSuffix [for]="kouzaRcvmnyDate"></mat-datepicker-toggle>
                    <mat-datepicker #kouzaRcvmnyDate></mat-datepicker>
                </mat-form-field>
            </div>

            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field [appearance]="getAppearance('rcvmnyKouzacode')"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%]">
                    <mat-label>入金口座</mat-label>
                    <mat-select formControlName="rcvmnyKouzacode" (selectionChange)="updateFeeList()"
                        class="disabled-select-color">
                        <mat-option *ngFor="let type of rcvmnyKouzaList" [value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field [appearance]="getAppearance('rcvmnyKeitaiCode')"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>入金形態</mat-label>
                    <mat-select formControlName="rcvmnyKeitaiCode" (selectionChange)="onChangeRcvmnyKeitai()"
                        class="disabled-select-color">
                        <mat-option *ngFor="let type of rcvmnyKeitaiList" [value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field [appearance]="getAppearance('kouzaRcvmnyBankofficecode')"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                    <mat-label>口座入金機関</mat-label>
                    <mat-select formControlName="kouzaRcvmnyBankofficecode" (selectionChange)="updateFeeList()"
                        class="disabled-select-color">
                        <mat-option *ngFor="let type of kouzaRcvmnyFcltList" [value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </mat-card-content>

        <mat-card-content>
            <div formArrayName="feeCont" *ngFor="let feeCont of feeCont.controls; let i = index">
                <div [formGroupName]="i">
                    <div
                        class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                        <mat-form-field appearance="fill"
                            class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                            <mat-label>手数料種類</mat-label>
                            <input matInput readonly="true" formControlName="feeSyuruiAname" autocomplete="off"
                                class="font-color-display-only" />
                        </mat-form-field>
                        <mat-form-field appearance="fill"
                            class="input-form tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                            <mat-label>手数料額(円)</mat-label>
                            <input numberInput min=0 max=999999999999 maxlength=12 matInput formControlName="feeMny"
                                style="text-align:right" autocomplete="off" class="font-color-display-only" />
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                <mat-card-actions>
                    <button type="submit" mat-raised-button color="primary" class="btn"
                        [disabled]="regInfFormGroup.invalid">登録</button>
                    <button *ngIf="isEdit" type="button" mat-raised-button color="primary" class="btn"
                        (click)="onClickRemove()">削除</button>
                </mat-card-actions>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                <mat-card-actions>
                    <button type="button" mat-raised-button color="primary" class="btn"
                        (click)="onClickCancel()">キャンセル</button>
                </mat-card-actions>
            </div>

        </mat-card-content>
    </div>
</mat-card>